import { ButtonHTMLAttributes, forwardRef, ReactNode } from "react";

export type IconButtonVariant = "filled" | "outlined";

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant: IconButtonVariant;
  icon: ReactNode;
  ariaLabel: string;
}

const VARIANT_CLASS: Record<IconButtonVariant, string> = {
  filled: "bg-[#FFD100] text-[#0D0D0D] hover:bg-[#EEC300]",
  outlined: "bg-transparent text-[#0D0D0D] border border-[#EAEAEA] hover:enabled:bg-[#FAFAFA]",
};

const BASE_CLASS =
  "inline-flex h-8 w-8 items-center justify-center rounded-full p-1 transition-colors " +
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0D0D0D] focus-visible:ring-offset-2 " +
  "disabled:cursor-not-allowed";

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ variant, icon, ariaLabel, className, type = "button", ...rest }, ref) => {
    const composedClass = [BASE_CLASS, VARIANT_CLASS[variant], className]
      .filter(Boolean)
      .join(" ");

    return (
      <button
        ref={ref}
        type={type}
        aria-label={ariaLabel}
        className={composedClass}
        {...rest}
      >
        {icon}
      </button>
    );
  }
);

IconButton.displayName = "IconButton";
